import { createApi } from '@rooquest/common'

function createNewApiInstance() {
  return createApi(window.env.API_URL)
}

const apiProxy = new Proxy(createNewApiInstance(), {
  apply(_, __, args) {
    const apiInstance = createNewApiInstance()
    return apiInstance(...(args as Parameters<typeof apiInstance>))
  },
}) as ReturnType<typeof createNewApiInstance>

export const api = apiProxy
